export const routeNames = {
  dashboard: 'Dashboard',
  login: 'Login',
  about: 'About',
  users: 'Users',
  userDetails: 'UserDetails',
  vehicles: 'Vehicles',
  vehicleDetails: 'VehicleDetails',
  addVehicle: 'AddVehicle',
  trips: 'Trips',
  tripDetails: 'TripDetails',
  reviews: 'Reviews',
  reviewDetails: 'ReviewDetails',
  settings: 'Settings',
  securityGroups: 'SecurityGroups',
  notFound: 'NotFound',
  restricted: 'Rescticted',
  notifications: 'Notifications',
  carData: 'CarData',
  createEvCar: 'CreateEvCar',
  evVehicles: 'evVehicles',
  evVehicleDetails: 'evVehicleDetails',
  evTrips: 'evTrips',
  evTripDetails: 'evTripDetails',
  evUsers: 'evUsers',
  evUserDetails: 'evUserDetails',
  evMap: 'evMap',
  evMapAreas: 'evMapAreas',
  evMapAreasAlert: 'evMapAreasAlert',
  evBalance: 'evBalance',
  evReports: 'evReports',
  evReviews: 'evReviews',
  evDiscrepencies: 'evDiscrepencies',
  evReserves: 'evReserves',
  evOutstanding: 'evOutstanding',
  evStatistic: 'evStatistic',
  evTripPoints: 'evTripPoints',
  evSettings: 'evSettings',
  evOwnerStatistics: 'evOwnerStatistics',
  localization: 'Localization',
  golfCars: 'golfCars',
  golfCarCreateMake: 'golfCarCreateMake',
  golfCarCreateModel: 'golfCarCreateModel',
  golfCarDetails: 'golfCarDetails',
  golfTrips: 'golfTrips',
  golfTripDetails: 'golfTripDetails',
  golfUsers: 'golfUsers',
  golfUserDetails: 'golfUserDetails',
  golfSettings: 'golfSettings',
  golfReserves: 'golfReserves',
  golfMap: 'golfMap',
  golfMapAreas: 'golfMapAreas',
  golfMapAreasAlert: 'golfMapAreasAlert',
  golfAreas: 'golfAreas',
  golfDashboard: 'golfDashboard',
  golfFinancialReport: 'golfFinancialReport',
  golfTariffSettings: 'golfTariffSettings',
  golfAdminRoles: 'golfAdminRoles',
  golfLocalization: 'golfLocalization',
}
